import { render, staticRenderFns } from "./AppCancel.vue?vue&type=template&id=6970f4a7&"
import script from "./AppCancel.vue?vue&type=script&lang=js&"
export * from "./AppCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports